export const SIZES = {
    Z: 'Z',
    XXXXS: 'XXXXS',
    XXXS: 'XXXS',
    XXS: 'XXS',
    XS: 'XS',
    S: 'S',
    M: 'M',
    L: 'L',
    XL: 'XL',
    XXL: 'XXL',
    XXXL: 'XXXL',
    XXXXL: 'XXXXL',
    G: 'G',
    XG: 'XG',
    XXG: 'XXG',
}

export const getPixelsFromSize = (size) => {
    if (size == null) {
        return 'auto'
    }

    switch (size) {
    case SIZES.Z:
        return 0
    case SIZES.XXXXS:
        return 2
    case SIZES.XXXS:
        return 4
    case SIZES.XXS:
        return 8
    case SIZES.XS:
        return 10
    case SIZES.S:
        return 12
    case SIZES.M:
        return 14
    case SIZES.L:
        return 16
    case SIZES.XL:
        return 20
    case SIZES.XXL:
        return 24
    case SIZES.XXXL:
        return 30
    case SIZES.XXXXL:
        return 40
    case SIZES.G:
        return 50
    case SIZES.XG:
        return 70
    case SIZES.XXG:
        return 110
    default:
        throw new Error(`Unknown size ${size}`)
    }
}
